export const DATE_MOBILE_OFFSET = '44px';
